var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('menu-button',{attrs:{"icon":"outdent","title":"Outdent","command":_vm.runCommand}})
}
var staticRenderFns = []

export { render, staticRenderFns }